import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

/**
 * RotatingTagline — cycles through a list of taglines with a soft mask-reveal transition.
 * Editorial, quiet, respects prefers-reduced-motion.
 */
export default function RotatingTagline({
  taglines = [],
  intervalMs = 3800,
  className = "",
  style = {},
  testId = "rotating-tagline",
}) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!taglines.length) return;
    const t = setInterval(() => setI((v) => (v + 1) % taglines.length), intervalMs);
    return () => clearInterval(t);
  }, [taglines, intervalMs]);

  if (!taglines.length) return null;

  return (
    <span
      className={`inline-block relative overflow-hidden align-baseline ${className}`}
      style={{ ...style }}
      data-testid={testId}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={i}
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          exit={{ y: "-110%", opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
          style={{ display: "inline-block" }}
        >
          {taglines[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
